"use strict"

import React, { useEffect, useRef, useState } from "react"

import OperatorAction from "./OperatorAction"
import ResizeSensor from "css-element-queries/src/ResizeSensor"
import { withAppSettingsConfig } from "../../config/AppSettingsConfigProvider"

const OperatorActionWrapper = ({ config }) => {
  const resizeRef = useRef()

  const closedActionClass = "operator-input-component actionInputInvisible"
  const openActionClass = "operator-input-component actionInputVisible"

  const [open, setOpen] = useState(false)

  const [authorized, setAuthorized] = useState(false)
  useEffect(() => {
    if (config.user && config.user.permissions) {
      setAuthorized(config.user.permissions.includes("add_operatoraction"))
    }
  }, [config.user])

  const element = document.getElementById("application-page")
  const [height, setHeight] = useState(element.clientHeight)

  new ResizeSensor(element, () => setHeight(element.clientHeight))

  if (resizeRef.current) {
    resizeRef.current["style"].height = `${height}px`
  }

  return (
    <div className={open ? openActionClass : closedActionClass} ref={resizeRef}>
      {authorized && <OperatorAction toggleVisibility={() => setOpen(!open)} open={open} height={height} />}
    </div>
  )
}

export default withAppSettingsConfig(OperatorActionWrapper)
